export interface CreateCollectionAndUserCheckRequest {
  branchCode: string
  lendType: string
}

export function CreateCollectionAndUserCheckRequestToJSON(
  value: CreateCollectionAndUserCheckRequest
): any {
  return {
    branch_code: value.branchCode !== '' ? value.branchCode : undefined,
    lend_type: value.lendType !== '' ? value.lendType : undefined
  }
}
